import React from 'react';
import { Typography } from '@mui/material';
import { VideoContainer, VideoWrapper, VideoIframe } from './YouTubeVideo.styled';

interface YouTubeVideoProps {
  videoId: string;
  title?: string;
  width?: string | number;
  height?: string | number;
  allowFullScreen?: boolean;
}

const YouTubeVideo: React.FC<YouTubeVideoProps> = ({
  videoId,
  title = 'YouTube video player',
  width = '100%',
  height = 315,
  allowFullScreen = true,
}) => {
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <VideoContainer>
      {title && (
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
      )}
      <VideoWrapper>
        <VideoIframe
          src={embedUrl}
          title={title}
          width={width}
          height={height}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen={allowFullScreen}
        />
      </VideoWrapper>
    </VideoContainer>
  );
};

export default YouTubeVideo; 